import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Checkbox } from "@/components/ui/checkbox";
import { Sun, ArrowUpRight } from "lucide-react";
import { DUE_STYLE, fmtDue } from "@/lib/todo";

export const MyDayCard = () => {
  const [data, setData] = useState(null);
  const load = () => api.get("/todo/summary").then((r) => setData(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);
  if (!data) return null;
  const c = data.counts;
  const complete = async (item) => { await api.patch(`/todo/items/${item.todo_id}`, { completed: true }); load(); };

  return (
    <div className="rounded-xl border border-slate-200 bg-white p-5" data-testid="my-day-card">
      <div className="flex items-start justify-between gap-3">
        <div><p className="overline">Personal to-dos</p><h2 className="text-lg font-bold tracking-tight text-slate-900 flex items-center gap-2"><Sun className="h-5 w-5 text-amber-500" />My Day</h2></div>
        <Link to="/my-day" className="text-sm text-slate-600 hover:text-slate-900 inline-flex items-center" data-testid="my-day-card-open">Open <ArrowUpRight className="h-3.5 w-3.5 ml-1" /></Link>
      </div>
      <div className="grid grid-cols-3 gap-2 mt-4">
        {[["overdue", "Overdue", "text-red-600"], ["due_today", "Due today", "text-amber-600"], ["due_soon", `Due in ${data.due_soon_days}d`, "text-sky-600"]].map(([k, l, tone]) => (
          <div key={k} className="rounded-lg bg-slate-50 border border-slate-100 px-3 py-2" data-testid={`my-day-card-${k}`}><div className={`text-2xl font-bold font-mono ${tone}`}>{c[k]}</div><div className="text-[11px] text-slate-500">{l}</div></div>
        ))}
      </div>
      <div className="mt-4 space-y-1.5" data-testid="my-day-card-focus">
        {data.focus.length === 0 ? <p className="text-sm text-slate-500">No to-dos due soon. {c.open > 0 ? `${c.open} open without urgency.` : "Add some on My Day."}</p> : data.focus.map((i) => (
          <label key={i.todo_id} className={`flex items-center gap-2 rounded-md border border-slate-200 border-l-4 px-2 py-1.5 text-sm ${DUE_STYLE[i.due_state].row}`} data-testid={`my-day-card-item-${i.todo_id}`}>
            <Checkbox onCheckedChange={() => complete(i)} data-testid={`my-day-card-check-${i.todo_id}`} />
            <span className="flex-1 truncate text-slate-900">{i.title}</span>
            <span className={`rounded border px-1.5 py-0.5 text-[11px] ${DUE_STYLE[i.due_state].chip}`}>{fmtDue(i.due_date)}</span>
          </label>
        ))}
      </div>
    </div>
  );
};
